import React from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../components/layout";
import { SEO } from "../components/common";
import { DocsNavigation } from "../components/layout";
import {
  Book,
  Code2,
  Wand2,
  Layout as LayoutIcon,
  FileJson,
  Blocks,
  LayoutTemplate,
} from "lucide-react";

export function DocumentationPage() {
  const navigate = useNavigate();

  const sections = [
    {
      icon: Book,
      title: "Getting Started",
      description: "Learn the basics of using Block Pattern Generator.",
      path: "/docs/getting-started",
      iconColor: "text-blue-400",
      bgColor: "bg-blue-500/20",
    },
    {
      icon: Wand2,
      title: "AI Generation",
      description: "Master AI-powered block creation.",
      path: "/docs/ai-generation",
      iconColor: "text-purple-400",
      bgColor: "bg-purple-500/20",
    },
    {
      icon: Blocks,
      title: "Block Types",
      description: "Explore available WordPress blocks.",
      path: "/docs/block-types",
      iconColor: "text-green-400",
      bgColor: "bg-green-500/20",
    },
    {
      icon: LayoutIcon,
      title: "Templates",
      description: "Work with pre-built templates.",
      path: "/docs/templates",
      iconColor: "text-yellow-400",
      bgColor: "bg-yellow-500/20",
    },
    {
      icon: Code2,
      title: "API Reference",
      description: "Integrate with our API.",
      path: "/docs/api-reference",
      iconColor: "text-red-400",
      bgColor: "bg-red-500/20",
    },
    {
      icon: FileJson,
      title: "Pattern Format",
      description: "Understanding pattern structure.",
      path: "/docs/pattern-format",
      iconColor: "text-indigo-400",
      bgColor: "bg-indigo-500/20",
    },
  ];

  return (
    <Layout fullWidth>
      <SEO
        title="Documentation | Block Pattern Generator Guide"
        description="Learn how to use Block Pattern Generator effectively. Comprehensive guides on AI generation, block types, templates, and API integration."
        keywords={[
          "wordpress documentation",
          "block patterns guide",
          "pattern generator tutorial",
          "wordpress blocks help",
        ]}
      />
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex gap-8">
          {/* Sidebar Navigation */}
          <div className="w-64 flex-shrink-0">
            <DocsNavigation />
          </div>

          {/* Main Content */}
          <div className="flex-1">
            <div className="max-w-3xl">
              <h1 className="text-4xl font-bold text-doc-heading mb-4">
                Documentation
              </h1>
              <p className="text-xl text-doc-text mb-8">
                Learn how to use Block Pattern Generator to create stunning
                WordPress block patterns.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              {sections.map(
                ({
                  icon: Icon,
                  title,
                  description,
                  path,
                  iconColor,
                  bgColor,
                }) => (
                  <div
                    key={path}
                    onClick={() => navigate(path)}
                    className="bg-doc-code-bg rounded-xl p-6 cursor-pointer hover:bg-gray-800 transition-all border border-doc-border"
                    role="link"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigate(path);
                      }
                    }}
                  >
                    <div
                      className={`${bgColor} rounded-lg w-12 h-12 flex items-center justify-center mb-4`}
                    >
                      <Icon
                        className={`h-6 w-6 ${iconColor}`}
                        aria-hidden="true"
                      />
                    </div>
                    <h2 className="text-xl font-semibold text-doc-heading mb-2">
                      {title}
                    </h2>
                    <p className="text-doc-text">{description}</p>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
